const Modal = require('./modal');
const template = require('./list-item-menu.tpl').default;

module.exports = DomClass(template, function ListItemMenu() {
	var _t = this;

	Modal.call(this.__dom.items);
	
	this.toggleButton.onclick = function() { _t.__dom.items.open(); }

	on(this.__dom.items, 'open').then(function() {
		_t.items.forEach(function(item) {
			if (item.__menu != _t) {
				on(item, 'select').then(function() {
					_t.__dom.items.close();
					on(_t, 'select').fire(item.action);
				});
				item.__menu == _t;
			}
		});
	});

});
